import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertDialog as SharedAlertDialog } from '@packages/ui';

type AlertDialogType = 'warning' | 'danger' | 'info' | 'success';

interface AlertDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  type?: AlertDialogType;
  confirmText?: string;
  onConfirm: () => void;
}

const AlertDialog: React.FC<AlertDialogProps> = ({ confirmText, ...props }) => {
  const { t } = useTranslation(['common_ui']);

  return (
    <SharedAlertDialog
      {...props}
      confirmText={confirmText ?? t('common_ui:dialog.alert.confirm')}
    />
  );
};

export default AlertDialog;
